export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15109.7a861db7.jpg";